import { Text } from '@mantine/core';
import { FC } from 'react';
import { useElementSize } from '@mantine/hooks';
import BookitupTable from '../../../../Atoms/BookitupTable';
import { Planning } from '../../../../Types/ResourceT';
import PlanningTableRow from './PlanningTableRow';

interface Props {
  plannings: Planning[];
  refresh: () => void;
}

const ResourcePlanningTable: FC<Props> = ({ plannings, refresh }) => {
  const { ref, width } = useElementSize();
  const showColumns = {
    showCategory: width > 550,
    showType: width > 450,
    showCounter: width > 400,
  };
  const columnCount =
    4 + (showColumns.showCategory ? 1 : 0) + (showColumns.showType ? 1 : 0) + (showColumns.showCounter ? 1 : 0);

  return (
    <BookitupTable>
      <thead>
        <tr ref={ref}>
          <th style={{ width: 30 }}> </th>
          <th style={{ width: 30 }}> </th>
          <th>Name</th>
          {showColumns.showCategory && <th style={{ width: 100 }}>Kategorie</th>}
          {showColumns.showType && <th style={{ width: 70 }}> Typ </th>}
          {showColumns.showCounter && <th style={{ width: 100 }}> Planung</th>}
          <th> </th>
        </tr>
      </thead>
      <tbody>
        {plannings.length === 0 && (
          <tr
            style={{ backgroundColor: 'transparent' }}
            onMouseEnter={(event) => {
              const target = event.currentTarget;
              target.style.backgroundColor = 'transparent';
            }}
            onMouseLeave={(event) => {
              const target = event.currentTarget;
              target.style.backgroundColor = 'transparent';
            }}
          >
            <td colSpan={columnCount} style={{ padding: '28px 20px', textAlign: 'center' }}>
              <Text italic color="dimmed" size="xs">
                Noch keine Planungen hinzugefugt.
              </Text>
            </td>
          </tr>
        )}
        {plannings.map((planning) => (
          <PlanningTableRow
            key={planning.id}
            planning={planning}
            refresh={refresh}
            showCategory={showColumns.showCategory}
            showType={showColumns.showType}
            showCounter={showColumns.showCounter}
          />
        ))}
      </tbody>
    </BookitupTable>
  );
};

export default ResourcePlanningTable;
